module.exports = __webpack_public_path__ + "static/media/Logo_AdminPortal.d37870b8.png";